import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, Autocomplete } from "@react-google-maps/api";
import loader from "./GoogleMapsLoader.js";

const containerStyle = {
  width: "100%",
  height: "60vh",
};

const LocationPicker = ({ onLocationSelect, fetchedLocation }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [map, setMap] = useState(null);

  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    loader.load().then(() => {
      setIsLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (
      isLoaded &&
      fetchedLocation?.coordinates?.length === 2 &&
      window.google
    ) {
      const [lat, lng] = fetchedLocation.coordinates;

      setMarkerPosition({ lat, lng });

      if (map) {
        map.panTo({ lat, lng });
        map.setZoom(16);
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results?.[0]) {
          if (inputRef.current) {
            inputRef.current.value = results[0].formatted_address;
          }
        }
      });
    }
  }, [isLoaded, fetchedLocation, map]);

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMarkerPosition({ lat, lng });
    onLocationSelect({ lat, lng });

    if (window.google && inputRef.current) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results?.[0]) {
          inputRef.current.value = results[0].formatted_address;
        }
      });
    }
  };

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current.getPlace();
    if (place?.geometry?.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      setMarkerPosition({ lat, lng });

      map.panTo({ lat, lng });
      map.setZoom(16);

      onLocationSelect({
        lat,
        lng,
        address: place.formatted_address,
      });
    }
  };

  const onLoadMap = (mapInstance) => {
    setMap(mapInstance);
  };

  if (!isLoaded) return <p>Loading map...</p>;

  return (
    <div>
      <div style={{ marginBottom: "10px" }}>
        <Autocomplete
          onLoad={(ref) => (autocompleteRef.current = ref)}
          onPlaceChanged={handlePlaceSelect}
        >
          <input
            ref={inputRef}
            type="text"
            placeholder="Search for a location"
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </Autocomplete>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={markerPosition || { lat: 26.4499, lng: 80.3319 }}
        zoom={markerPosition ? 16 : 12}
        onClick={handleMapClick}
        onLoad={onLoadMap}
      >
        {markerPosition && <Marker position={markerPosition} />}
      </GoogleMap>
    </div>
  );
};

export default LocationPicker;
